import { Provider } from '@angular/core';
import {
  StatesFacadeService,
  DispatchersFacadeService,
} from '../dispatchers-facade.service';
import { ServiceConfigurationLoadedStateManager } from '../service-configuration-loaded.service';
import {
  ServiceRequestLoadedStateManager,
  DraftServiceRequestLoadedStateManager,
  ServiceRequestUpdatedStateManager,
  ServiceRequestCreatedStateManager,
  DraftServiceRequestSavedStateManager,
  FormsDefinedStateManager,
  InvalidFlowStateManager,
  SuccessfulFlowStateManager,
  InvalidServiceRequestSubmitStateManager,
  FlowStateManager,
  PaymentErrorStateManager,
  PaymentConfirmedStateManager,
  PaymentGatewayStateManager,
  WorkflowStartedStateManager,
  ServicePageLandedStateManager,
} from '../service-request-loaded.service';
import { ApplicantStateService } from '../../ApplicantState.service';
import { AnalyticsListenersService } from '../../analytics-management/analytics.listeners.service';
import { ProcedureInstanceListenersService } from '../../analytics-management/procedure-instance-listeners.service';
import { ServiceMetadataLoadedStateManager } from '../service-metadata-loaded-state.service';

export const serviceComponentSharedProviders: Provider[] = [
  {
    provide: 'stateFacadeService',
    useClass: StatesFacadeService,
  },
  { provide: 'applicantStateService', useClass: ApplicantStateService },
  { provide: 'dispatcherService', useClass: DispatchersFacadeService },

  {
    provide: 'serviceConfigurationLoadedStateManager',
    useClass: ServiceConfigurationLoadedStateManager,
  },
  {
    provide: 'serviceRequestLoadedStateManager',
    useClass: ServiceRequestLoadedStateManager,
  },
  {
    provide: 'serviceRequestUpdatedStateManager',
    useClass: ServiceRequestUpdatedStateManager,
  },
  {
    provide: 'serviceRequestCreatedStateManager',
    useClass: ServiceRequestCreatedStateManager,
  },
  {
    provide: 'invalidServiceRequestSubmitManager',
    useClass: InvalidServiceRequestSubmitStateManager,
  },
  {
    provide: 'draftServiceRequestSavedStateManager',
    useClass: DraftServiceRequestSavedStateManager,
  },
  {
    provide: 'draftServiceRequestLoadedStateManager',
    useClass: DraftServiceRequestLoadedStateManager,
  },
  {
    provide: 'analyticsListenersService',
    useClass: AnalyticsListenersService,
  },
  {
    provide: 'procedureInstanceListenersService',
    useClass: ProcedureInstanceListenersService,
  },
  {
    provide: 'formsDefinedStateManager',
    useClass: FormsDefinedStateManager,
  },
  {
    provide: 'invalidFlowManager',
    useExisting: InvalidFlowStateManager,
  },
  {
    provide: 'successfulFlow',
    useExisting: SuccessfulFlowStateManager,
  },
  {
    provide: 'flow',
    useExisting: FlowStateManager,
  },
  {
    provide: 'paymentGateway',
    useExisting: PaymentGatewayStateManager,
  },
  {
    provide: 'paymentConfirmed',
    useExisting: PaymentConfirmedStateManager,
  },
  {
    provide: 'paymentError',
    useExisting: PaymentErrorStateManager,
  },
  {
    provide: 'workflowStarted',
    useExisting: WorkflowStartedStateManager,
  },
  {
    provide: 'servicePageLanded',
    useExisting: ServicePageLandedStateManager,
  },
  {
    provide: 'serviceMetadataLoaded',
    useExisting: ServiceMetadataLoadedStateManager,
  },
];
